
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigModule } from '~/store/modules/config';
import { copyToClipboard } from '~common-helpers';

@Component
export default class CopyRouteWrapper extends Vue {
    @Prop() readonly type!: string;
    @Prop() readonly id!: string;

    copyLinkToClipboard() {
        function linkParticle(type: string, id: string) {
            switch (type) {
                case 'user':
                    return `/user/${id}`;
                case 'home':
                    return `/home/${id}`;
                case 'gateway':
                    return `/gateway/${id}`;
                case 'module':
                    return  `/module/${id}`;
            }
        }
        const { userIdentifier, homeId, gatewayId } = this.$route.params;
        let link = ConfigModule.supportUrl + (userIdentifier ? linkParticle('user', userIdentifier) : '');
        if (this.type === 'home') {
            link += linkParticle('home', this.id);
        }
        if (this.type === 'gateway') {
            if (homeId) {
                link += linkParticle('home', homeId);
            }
            link += linkParticle('gateway', this.id);
        }
        if (this.type === 'module') {
            if (homeId) {
                link += linkParticle('home', homeId);
            }
            if (gatewayId) {
                link += linkParticle('gateway', gatewayId);
            }
            link += linkParticle('module', this.id);
        }

        copyToClipboard(link);
    }
}
